export const ProjectCodeSidebar = {
  extends: 'DocsSidebar',
  childExtends: {
    state: {
      show: true
    }
  },
  position: 'relative',
  top: '0',
  gap: 'B2',
  childProps: {
    NumbCaption: {
      position: 'sticky',
      top: '0',
      theme: 'common-box',
      padding: 'W -',
      href: null,
      Numb: null,
      CaptionTitle: {
        ':hover': {
          textDecoration: 'underline'
        },
        Text: {
          text: (el, s) => el.call('polyglot', s.title || '')
        },
        onClick: (ev, el, s) => {
          ev.preventDefault()
          ev.stopPropagation()
          el.lookup('Overflow').state.update(
            {
              type: s.key,
              key: null
            },
            {
              forceMonacoUpdate: true
            }
          )
        }
      },
      Text: null,
      SquareButton: {
        extends: ['CanvasButton', 'SquareButton'],
        margin: '-Y1 -',
        padding: 'X',
        round: 'X',
        icon: (el, s) => (s.show ? 'arrow angle up' : 'arrow angle down'),
        ariaLabel: (el, s) =>
          el.call(
            'polyglot',
            s.show ? 'editor.sidebar.collapseSection' : 'editor.sidebar.expandSection'
          ),
        hide: (el, s) => !s.sub_links?.length,
        onClick: (ev, el, s) => {
          ev.preventDefault()
          ev.stopPropagation()
          s.toggle('show')
        }
      }
    },
    NavLinks: {
      margin: 'Z - -',
      // Indent-guide border removed (border-habit sweep, design-direction.md
      // §8) — the existing left padding already reads as the nesting cue;
      // this isn't a dense-data-table hairline (§2.5's one surviving-stroke
      // exception for row/column rules).
      padding: '- - - Z2',
      hide: (el, s) => !s.show || !s.sub_links?.length,
      childProps: {
        NumbCaption: {
          Numb: null,
          href: null,
          ':hover': {
            color: 'title'
          },
          // Reads the selection from the SAME place onClick below writes it —
          // the `Overflow` ancestor's state `{ type, key }`. The previous form
          // passed a 2-arg `(el, s)` predicate to `el.lookup`, which invokes it
          // with ONE argument (element/src/methods.js), so `s` was undefined and
          // `s.selectedKey` threw on the first ancestor; `selectedKey` was also
          // written nowhere in the repo, so it could never have matched anyway.
          isActive: (el, s) => {
            const selection = el.lookup('Overflow')?.state
            if (!selection) return false
            return s.parent.key === selection.type && s.key === selection.key
          },
          onClick: (ev, el, s) => {
            ev.preventDefault()
            ev.stopPropagation()
            el.lookup('Overflow').state.update(
              {
                type: s.parent.key,
                key: s.key
              },
              {
                forceMonacoUpdate: true
              }
            )
          }
        }
      }
    }
  },
  children: (el) => {
    const arrayize = (obj = {}) =>
      Object.keys(obj).map((key) => ({
        title: key,
        key
      }))
    const rootData = [
      {
        title: '~',
        sub_links: [
          {
            title: 'index.html',
            key: 'index.html'
          },
          {
            title: 'app.js',
            key: 'app.js'
          },
          {
            title: 'package.json',
            key: 'package.json'
          },
          {
            title: 'sitemap.xml',
            key: 'sitemap.xml'
          }
        ]
      },
      {
        title: 'editor.quickAdd.component2',
        key: 'components',
        sub_links: arrayize(el.getData('components')).slice(0, 10)
      },
      {
        title: 'editor.command.category.pages',
        key: 'pages',
        sub_links: arrayize(el.getData('pages')).slice(0, 10)
      },
      {
        title: 'editor.panel.state',
        key: 'state',
        sub_links: arrayize(el.getData('state')).slice(0, 10)
      },
      {
        title: 'editor.panel.functions',
        key: 'functions',
        sub_links: arrayize(el.getData('functions')).slice(0, 10)
      },
      {
        title: 'editor.sidebar.methods',
        key: 'methods',
        sub_links: arrayize(el.getData('methods'))
      },
      {
        title: 'editor.sidebar.snippets',
        key: 'snippets',
        sub_links: arrayize(el.getData('snippers'))
      },
      {
        title: 'shell.app.files',
        key: 'files',
        sub_links: arrayize(el.getData('files'))
      },
      {
        title: 'editor.ds.title',
        key: 'designSystem',
        sub_links: arrayize(el.getData('designSystem'))
      },
      {
        title: 'editor.panel.dependencies',
        key: 'dependencies'
      },
      {
        title: 'editor.panel.integrations',
        key: 'integrations'
      },
      {
        title: 'shell.pageTitle.canvas',
        key: 'canvas'
      },
      {
        title: 'editor.zoombar.settings',
        key: 'settings'
      },
      {
        title: 'editor.sidebar.secrets',
        key: 'secrets'
      }
    ]
    return rootData
  }
}
